module.exports = {"140122100":"黄寨镇","140122101":"大盂镇","140122102":"东黄水镇","140122103":"泥屯镇","140122104":"中心镇建设管理办公室","140122200":"高村乡","140122201":"侯村乡","140122202":"凌井店乡","140122203":"西凌井乡","140122204":"北小店乡","140122205":"杨兴乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140122.json
// module id = 266
// module chunks = 0